import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { FaEdit, FaFileDownload, FaUpload } from 'react-icons/fa';
import DataTable from 'react-data-table-component';
import moment from 'moment';
import ErpTemplate from '../../components/ErpTemplate';
import UploadButton from '../../components/UploadButton';
import api from '../../services/api';
import FormButton from '../../components/FormButton';
import IconButton from '../../components/IconButton';

const BRAND_NAVY = '#1f3c88';
const BRAND_BLUE = '#2d7ff9';
const BRAND_BORDER = '#dbe8f8';

export default function EventoImportarOpcaoAereo({ match }) {
    const id = match.params.id;
    const empresa = localStorage.getItem('empresa');
    const nomeEmpresa = localStorage.getItem('nomeEmpresa');
    const [arquivos, setArquivos] = useState([]);
    const [nomeEvento, setNomeEvento] = useState('');
    const token = localStorage.getItem('token');
    const { state } = useLocation();
    const history = useHistory();

    useEffect(() => {
        if (state?.nomeEvento) {
            setNomeEvento(state.nomeEvento);
        }
    }, [state]);

    const buscarArquivos = () => {
        api({
            method: 'get',
            action: '/eventoArquivo',
            token,
            params: {
                tipo: 'opcaoAereo',
                evento: id,
            },
        }).then((response) => {
            setArquivos(response.data.data);
        }).catch(() => {
            toast.error('Erro ao carregar arquivos importados');
        });
    };

    const buscarEvento = () => {
        if (!id || nomeEvento) {
            return;
        }

        api({
            method: 'get',
            action: '/evento/' + id,
            token,
        }).then((response) => {
            const evento = response.data.data;
            setNomeEvento(evento?.nomersvp ?? evento?.nome ?? '');
        }).catch(() => {
            // fallback silencioso
        });
    };

    useEffect(() => {
        buscarArquivos();
        // eslint-disable-next-line
    }, [id]);

    useEffect(() => {
        buscarEvento();
        // eslint-disable-next-line
    }, [id, nomeEvento]);

    return (
        <ErpTemplate>
            <div className="main-content container-fluid">
                <div className="page-title mb-3">
                    <div
                        style={{
                            background: 'linear-gradient(135deg, #f7fbff 0%, #edf4ff 100%)',
                            border: `1px solid ${BRAND_BORDER}`,
                            borderRadius: 22,
                            boxShadow: '0 18px 40px rgba(31, 60, 136, 0.08)',
                            padding: 24,
                        }}
                    >
                        <div
                            style={{
                                color: BRAND_BLUE,
                                fontSize: 12,
                                fontWeight: 800,
                                letterSpacing: '0.12em',
                                marginBottom: 10,
                                textTransform: 'uppercase',
                            }}
                        >
                            Opções de Aéreo
                        </div>
                        <h3 style={{ color: BRAND_NAVY, fontSize: 34, fontWeight: 700, marginBottom: 8 }}>
                            {nomeEvento || 'Evento sem nome carregado'}
                        </h3>
                        <div style={{ color: '#60728f', fontSize: 16 }}>
                            Importe uma nova planilha de opções ou entre no modo de edição manual para ajustar dados já cadastrados.
                        </div>
                    </div>
                </div>

                <section id="multiple-column-form">
                    <div className="row match-height">
                        <div className="col-sm-12">
                            <div className="card border-0" style={{ borderRadius: 22, overflow: 'hidden', boxShadow: '0 18px 40px rgba(31, 60, 136, 0.08)' }}>
                                <div className="card-content">
                                    <div className="card-body" style={{ padding: 24 }}>
                                        <div
                                            className="mb-4"
                                            style={{
                                                background: 'linear-gradient(135deg, #1f3c88 0%, #2d7ff9 100%)',
                                                borderRadius: 18,
                                                boxShadow: '0 16px 32px rgba(45, 127, 249, 0.22)',
                                                color: '#fff',
                                                padding: 20,
                                            }}
                                        >
                                            <div style={{ fontSize: 20, fontWeight: 700, marginBottom: 6 }}>
                                                Fluxo de importação e manutenção
                                            </div>
                                            <div style={{ opacity: 0.9 }}>
                                                Use o XLS quando quiser subir uma malha completa. Para correção pontual, prefira a edição manual e evite reimportações desnecessárias.
                                            </div>
                                        </div>

                                        <div className="d-flex flex-wrap align-items-center mb-2">
                                            <div style={{ marginRight: 12, marginBottom: 12 }}>
                                                <UploadButton
                                                    icon={<FaUpload size={18} />}
                                                    color="primary"
                                                    acaoApi="eventoImportarOpcaoAereo"
                                                    title="Selecionar Arquivo"
                                                    beforeSend={() => {
                                                        toast.info('Aguarde, isso pode levar alguns minutos');
                                                    }}
                                                    callBack={(data) => {
                                                        if (data.result === 'sucesso') {
                                                            toast.success('Importação finalizada');
                                                            history.push('/cadastroEventoRsvpOpcaoAereo/' + id);
                                                            return;
                                                        }

                                                        toast.error(data.message || data.error || 'Erro desconhecido');
                                                    }}
                                                    dados={{
                                                        empresa,
                                                        evento: id,
                                                    }}
                                                >
                                                    Selecionar Arquivo
                                                </UploadButton>
                                            </div>

                                            <div style={{ marginRight: 12, marginBottom: 12 }}>
                                                <IconButton
                                                    to={'/cadastroEventoRsvpOpcaoAereo/' + id}
                                                    icon={<FaEdit size={18} />}
                                                    color="primary"
                                                >
                                                    Editar Opções Atuais
                                                </IconButton>
                                            </div>

                                            <div style={{ marginBottom: 12 }}>
                                                <FormButton
                                                    method="get"
                                                    target="_blank"
                                                    title="Baixar modelo"
                                                    action={(process.env.PUBLIC_URL ?? '') + '/modelo-opcoes-aereo.xlsx'}
                                                    icon={<FaFileDownload size={18} />}
                                                    color="primary"
                                                >
                                                    Baixar Modelo XLS
                                                </FormButton>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="card border-0 mt-3" style={{ borderRadius: 22, overflow: 'hidden', boxShadow: '0 18px 40px rgba(31, 60, 136, 0.08)' }}>
                                <div className="card-content">
                                    <div className="card-body" style={{ padding: 24 }}>
                                        <div className="d-flex flex-wrap align-items-center justify-content-between mb-3">
                                            <div>
                                                <h4 style={{ color: BRAND_NAVY, fontWeight: 700, marginBottom: 4 }}>
                                                    Histórico de arquivos
                                                </h4>
                                                <div style={{ color: '#6f809b' }}>
                                                    Últimos arquivos vinculados a este evento.
                                                </div>
                                            </div>
                                        </div>

                                        <div className="table-responsive">
                                            <DataTable
                                                noContextMenu="true"
                                                noDataComponent="Nenhum registro"
                                                className="table mb-0"
                                                columns={[
                                                    {
                                                        name: 'Arquivo',
                                                        selector: (row) => row.arquivo?.id ?? '',
                                                        cell: (row) => row.arquivo?.id ? (
                                                            <FormButton
                                                                method="get"
                                                                title="Baixar arquivo"
                                                                action={process.env.REACT_APP_API_URL + '/eventoArquivo/' + row.id}
                                                                icon={<FaFileDownload size={18} />}
                                                                color="primary"
                                                                data={{
                                                                    token: localStorage.getItem('token'),
                                                                }}
                                                            />
                                                        ) : null,
                                                        width: '90px',
                                                    },
                                                    {
                                                        name: 'Data',
                                                        selector: 'created_at',
                                                        width: '220px',
                                                        cell: (row) => moment(row.created_at).format('DD/MM/YYYY HH:mm'),
                                                    },
                                                    {
                                                        name: 'Operador',
                                                        selector: (row) => row.operador?.nome ?? '',
                                                        cell: (row) => row.operador?.nome ?? '',
                                                        width: '220px',
                                                    },
                                                ]}
                                                data={arquivos}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </ErpTemplate>
    );
}
